// extracted by mini-css-extract-plugin
export default {"para":"styles_para__IwMxp","Wrapper":"styles_Wrapper__DYtGZ","Main":"styles_Main__2MD1e"};